import { useSelector } from 'react-redux'
import { Column, GridContainer, H2, Row } from '@vp/swan'
import ReactMarkdown from 'react-markdown'
import { getMetadata } from 'client/store/config/reducer'

export const SecondaryContent = () => {
  const galleryMetadata = useSelector(getMetadata)

  return (
    <GridContainer className="secondary-content-container" component="section">
      <Row>
        <Column span={12} spanLg={10} spanMd={10}>
          <H2>{galleryMetadata?.secondaryHeader}</H2>
        </Column>
      </Row>
      {galleryMetadata?.secondaryContent && (
        <Row>
          <Column span={12} spanLg={10} spanMd={10}>
            <ReactMarkdown>{galleryMetadata.secondaryContent}</ReactMarkdown>
          </Column>
        </Row>
      )}
    </GridContainer>
  )
}
